export default "__VITE_ASSET__CqWys1XM__"